module.exports = __webpack_public_path__ + "img/acme.2215d918.png";